// ResetPassword.jsx
import React, { useState, useEffect } from "react";
import { resetPassword } from "../services/authService";

function ResetPassword() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [msg, setMsg] = useState("");

    useEffect(() => {
        if (!token) setMsg("Enlace inválido.");
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (pwd !== pwd2) { setMsg("Las contraseñas no coinciden"); return; }
        if (pwd.length < 8) { setMsg("Mínimo 8 caracteres"); return; }
        try {
            await resetPassword(token, pwd);
            setMsg("Contraseña actualizada. Ya puedes iniciar sesión.");
        } catch (e) {
            setMsg(e.message);
        }
    };

    return (
        <div className="panel">
            <h2>Restablecer contraseña</h2>
            {msg && <p>{msg}</p>}
            {token && (
                <form onSubmit={handleSubmit}>
                    <input type="password" placeholder="Nueva contraseña" value={pwd} onChange={e => setPwd(e.target.value)} required />
                    <input type="password" placeholder="Repite contraseña" value={pwd2} onChange={e => setPwd2(e.target.value)} required />
                    <button type="submit">Guardar</button>
                </form>
            )}
        </div>
    );
}

export default ResetPassword;